// extracted by mini-css-extract-plugin
export default {"container":"pc_container__odgaD","content":"pc_content__KlcGf","music":"pc_music__4jWK+","play":"pc_play__bHoey","spin":"pc_spin__pLkRU"};